export type StoreTimezone = { timezone?: string | null };

function storeClock(timezone: unknown) {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };
  try {
    return new Intl.DateTimeFormat('en-GB', { ...options,
      timeZone: typeof timezone === 'string' && timezone ? timezone : 'America/Sao_Paulo' });
  } catch {
    // Mesmo padrão da API para cadastros antigos sem um fuso válido.
    return new Intl.DateTimeFormat('en-GB', { ...options, timeZone: 'America/Sao_Paulo' });
  }
}

const clockParts = (clock: Intl.DateTimeFormat, date: Date) =>
  Object.fromEntries(clock.formatToParts(date).map(part => [part.type, part.value]));

export function storeCalendar(company: StoreTimezone | null | undefined, now = new Date()) {
  const parts = clockParts(storeClock(company?.timezone), now);
  const date = `${parts.year}-${parts.month}-${parts.day}`;
  return { date, dateTime: `${date}T${parts.hour}:${parts.minute}:00`,
    dayOfWeek: new Date(`${date}T12:00:00Z`).getUTCDay(),
    hour: Number(parts.hour), minute: Number(parts.minute) };
}

export function scheduledStoreDate(company: StoreTimezone | null | undefined, day: string, hour: string) {
  const clock = storeClock(company?.timezone);
  // A escolha visual é a hora da loja; converte para um instante sem usar o fuso do aparelho.
  const calendar = `${day}T${hour}:00`;
  const target = new Date(`${calendar}Z`).getTime();
  if (!Number.isFinite(target) || new Date(target).toISOString().slice(0, 16) !== calendar.slice(0, 16)) {
    throw new Error('Informe uma data válida para o agendamento.');
  }
  let instant = target;
  for (let attempt = 0; attempt < 3; attempt++) {
    const parts = clockParts(clock, new Date(instant));
    const local = new Date(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:00Z`).getTime();
    if (local === target) return new Date(instant);
    instant += target - local;
  }
  throw new Error('Informe uma data e horário válidos para o agendamento.');
}
